"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmbientValue = void 0;
/**
 * The ambient value is used when there is a difference between
 * the invocation type used during the invocation phase and the execution type used during the invocation processing.
 * The ambient value is value that is not now by the invoker but will be resolved during the invocation processing
 */
class AmbientValue {
}
exports.AmbientValue = AmbientValue;
//# sourceMappingURL=AmbientValue.js.map